<script>
export default {
    name: "VTextFieldDatePicker",
    inheritAttrs: false,
    data() {
        return {
            isShow: false,
            pickerDateRaw: null,
        };
    },
    props: {
        value: {
            type: String,
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD',
        },
        humanFormat: {
            type: String,
            default: 'll',
        },
        prependIcon: {
            default: "mdi-calendar",
        },
        min: {},
        max: {},
    },
    computed: {
        userFriendlyDate() {
            return this.date ? this.$moment(this.date, this.format).format(this.humanFormat) : '';
        },
        date: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            },
        },
        pickerDateDefault() {
            return this.min && this.max &&
                this.$moment.min(
                    this.$moment(this.max),
                    this.$moment.max(this.$moment(this.min), this.$moment())
                ).format("YYYY-MM-DD") || undefined;
        },
        pickerDate: {
            get() {
                return this.pickerDateRaw || this.pickerDateDefault;
            },
            set(v) {
                this.pickerDateRaw = v;
            },
        },
    },
}
</script>

<template>
    <v-menu
        v-model="isShow"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-bind="$attrs"
                v-on="on"
                :value="userFriendlyDate"
                :prepend-icon="prependIcon"
                :class="[$vnode.data.staticClass, $vnode.data.class]"
                @click:clear="date = null"
                readonly
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            :min="min"
            :max="max"
            :picker-date.sync="pickerDate"
            :first-day-of-week="1"
            @input="isShow = false"
        ></v-date-picker>
    </v-menu>
</template>

<style scoped lang="scss">

</style>
